/**
 * @file AppLayout.jsx
 * @author Rishikesh
 * @date 2024-09-09
 * @description Layout which give the app for future modifications.
 */
import React from "react";
import { Outlet } from "react-router-dom";

const AppLayout = () => {
  return <Outlet />;
};

export default AppLayout;
